import type { Api } from '@pflegenavi/shared-frontend/platform';
import {
  get,
  getApiBaseUrl,
  modify,
} from '@pflegenavi/shared-frontend/platform';
import type {
  ServiceProviderPaymentsStripeAccountControllerBodyTypes,
  ServiceProviderPaymentsStripeAccountControllerResultTypes,
} from '@pflegenavi/service-provider-shared/api-endpoints';
import { ServiceProviderPaymentsStripeAccountControllerDefinition } from '@pflegenavi/service-provider-shared/api-endpoints';
import type { Tenant } from '@pflegenavi/frontend/tenant';
import type { AuthenticationContext } from '@pflegenavi/frontend/authentication';

export interface IServiceProviderStripeApi extends Api {
  getServiceProviderStripeAccount(dataIn: {
    params: {
      globalServiceProviderId: string;
    };
  }): Promise<
    ServiceProviderPaymentsStripeAccountControllerResultTypes['getServiceProviderStripeAccount']
  >;

  createServiceProviderStripeAccount(dataIn: {
    params: { globalServiceProviderId: string };
    body: ServiceProviderPaymentsStripeAccountControllerBodyTypes['createServiceProviderStripeAccount'];
  }): Promise<
    ServiceProviderPaymentsStripeAccountControllerResultTypes['createServiceProviderStripeAccount']
  >;

  refetchServiceProviderStripeAccount(dataIn: {
    params: { globalServiceProviderId: string };
    body: ServiceProviderPaymentsStripeAccountControllerBodyTypes['refetchServiceProviderStripeAccount'];
  }): Promise<
    ServiceProviderPaymentsStripeAccountControllerResultTypes['refetchServiceProviderStripeAccount']
  >;
}

export class ServiceProviderStripeApi implements IServiceProviderStripeApi {
  baseUrl: string;

  getServiceProviderStripeAccount: IServiceProviderStripeApi['getServiceProviderStripeAccount'];
  createServiceProviderStripeAccount: IServiceProviderStripeApi['createServiceProviderStripeAccount'];
  refetchServiceProviderStripeAccount: IServiceProviderStripeApi['refetchServiceProviderStripeAccount'];

  constructor(
    tenantId: Tenant,
    public authContext: AuthenticationContext,
    apiUrl?: string
  ) {
    this.baseUrl = getApiBaseUrl(tenantId, apiUrl);

    this.getServiceProviderStripeAccount = get({
      authContext,
      url: (params) => {
        return `${this.baseUrl}/${ServiceProviderPaymentsStripeAccountControllerDefinition.controller}/${ServiceProviderPaymentsStripeAccountControllerDefinition.endpoints.getServiceProviderStripeAccount.url}`.replace(
          ':globalServiceProviderId',
          params.globalServiceProviderId
        );
      },
    });

    this.createServiceProviderStripeAccount = modify({
      authContext,
      method: 'POST',
      url: (params) => {
        return `${this.baseUrl}/${ServiceProviderPaymentsStripeAccountControllerDefinition.controller}/${ServiceProviderPaymentsStripeAccountControllerDefinition.endpoints.createServiceProviderStripeAccount.url}`.replace(
          ':globalServiceProviderId',
          params.globalServiceProviderId
        );
      },
    });

    this.refetchServiceProviderStripeAccount = modify({
      authContext,
      method: 'POST',
      url: (params) => {
        return `${this.baseUrl}/${ServiceProviderPaymentsStripeAccountControllerDefinition.controller}/${ServiceProviderPaymentsStripeAccountControllerDefinition.endpoints.refetchServiceProviderStripeAccount.url}`.replace(
          ':globalServiceProviderId',
          params.globalServiceProviderId
        );
      },
    });
  }
}
